// No React imports needed - this is a plain JavaScript module

// Simple global store for Supabase status
let supabaseDown = false;
const listeners: ((down: boolean) => void)[] = [];
let retryCallback: (() => void) | null = null;
let lastRetryableFn: (() => Promise<any>) | null = null;

export const supabaseStatusStore = {
  setOutage(status: boolean) {
    supabaseDown = status;
    listeners.forEach((cb) => cb(status));
  },
  subscribe(cb: (down: boolean) => void) {
    listeners.push(cb);
    return () => {
      const idx = listeners.indexOf(cb);
      if (idx !== -1) listeners.splice(idx, 1);
    };
  },
  get() {
    return supabaseDown;
  },
  setRetry(fn: () => void) {
    retryCallback = fn;
  },
  retry() {
    if (retryCallback) retryCallback();
  },
  setLastRetryable(fn: () => Promise<any>) {
    lastRetryableFn = fn;
  },
  async retryLast() {
    if (lastRetryableFn) return await lastRetryableFn();
    return null;
  },
};

// TODO: Replace with real showToast import if available
function showToast(message: string, type: 'error' | 'success' | 'info' = 'info') {
  if (typeof window !== 'undefined') {
    window.alert(`[${type.toUpperCase()}] ${message}`);
  } else {
    console.log(`[TOAST:${type}]`, message);
  }
}

export async function withSupabaseAvailability<T>(fn: () => Promise<T>): Promise<T | null> {
  try {
    const result = await fn();
    supabaseStatusStore.setOutage(false);
    supabaseStatusStore.setLastRetryable(fn);
    return result;
  } catch (error: any) {
    const message = error?.message || '';
    const isNetworkError =
      message.includes('Failed to fetch') ||
      message.includes('NetworkError') ||
      message.includes('CORS') ||
      (typeof error === 'object' && error?.name === 'TypeError');

    if (isNetworkError) {
      supabaseStatusStore.setOutage(true); // triggers banner
      supabaseStatusStore.setLastRetryable(fn);
      showToast('⚠️ Supabase is currently unreachable. Please try again shortly.');
      return null;
    }

    // Not a Supabase outage — propagate real error
    throw error;
  }
} 